import { Sidebar } from "primereact/sidebar";

import commonStyle from "../content/CommonStyles.module.css";

import DocumentArchiveTable from "./DocumentArchiveTable";

const DocumentArchive = ({sbVisible, onHide, documents, lazyState, onPage, totalRecords, toast}) => {
    return(
    <Sidebar visible={sbVisible} onHide={onHide} position="right" className={commonStyle.sidebarTable}>
        <DocumentArchiveTable documents={documents} lazyState={lazyState} onPage={onPage} totalRecords={totalRecords} toast={toast}/>
    </Sidebar>)
}

export default DocumentArchive;